import React from "react";


import parseHTML from "html-react-parser";


import { Col } from "react-bootstrap";


import "./index.scss";


type CardSubTitleComponentProps = {
    title: string;
    size?: 's' | 'md' | 'lg';
};


export const CardSubTitleDComponent:React.FC<CardSubTitleComponentProps> = ({
    title, size = 'm'
}) => {

    if (!title) {
        return null;
    }

    return (
        <Col xs={12} className={`card-component__sub-title card-component__sub-title--${size}`}>
            <span>{parseHTML(title)}</span>
        </Col>
    );

};


export default CardSubTitleDComponent;
